import React from 'react';
import TabPanes from '@/components/tabs/TabPanes';
import { userGroupTabs } from '../constants';
import UsergroupUsersTable from '../containers/UsergroupUsersTable';

const tabs = {
  [userGroupTabs.USERS.name]: { Content: UsergroupUsersTable },
};

const UsergroupPanelTabs = ({ category, code, isDuplicate }) => {
  const onRender = (name) => {
    const { Content } = tabs[name];
    return { content: (<Content code={code} category={category} isDuplicate={isDuplicate} />) };
  };

  return (
    <TabPanes
      activeIndex={0}
      className="aridhia-usergroup-panel-tabs"
      entity="usergroup"
      indexes={[0]}
      onRender={onRender}
      pointing
      secondary
      tabs={userGroupTabs}
    />
  );
};

export default UsergroupPanelTabs;
